import React, {useState} from 'react';

import './index.less';

export default function (props) {
  return <div className="fixed-footer">{props.children}</div>;
}
